<template>
  <div class="page">
    <!-- 顶部登录按钮（全局组件） -->
    <LoginButton class="login-btn" />

    <!-- 标题 -->
    <div class="title-row">
      <span class="page-title">请选择您的面试官</span>
    </div>

    <!-- 角色选择区 -->
    <div class="stage">
      <div class="characters" :class="{ 'with-panel': selectedIndex !== -1 }">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="character"
          :class="{
            'is-selected': selectedIndex === index,
            'is-dimmed': selectedIndex !== -1 && selectedIndex !== index,
            'pos-left': index === 0,
            'pos-right': index === 1,
            'is-hovered': hoveredIndex === index
          }"
          @click="handleCardClick(index)"
          @mouseenter="handleMouseEnter(index)"
          @mouseleave="handleMouseLeave()"
        >
          <div
            class="character-image"
            :style="{ backgroundImage: `url(${item.image})` }"
          />
          <div class="select-dot" :class="{ checked: selectedIndex === index || hoveredIndex === index }" />
        </div>
      </div>

      <!-- 右侧人物被选中后的资料卡 -->
      <transition name="panel" appear>
        <div v-if="selectedIndex !== -1" class="profile-container">
          <div class="profile-panel">
            <div class="profile-header" :style="{ justifyContent: headerJustify }">
              <div class="profile-name">{{ currentProfileInfo.name }}</div>
            </div>
            <div class="profile-body">
              <ul class="profile-list">
                <li 
                  v-for="(line, i) in currentProfileInfo.intros" 
                  :key="i"
                  :class="{
                    'section-title': line.includes('●'),
                    'check-item': line.includes('√')
                  }"
                >
                  {{ line }}
                </li>
              </ul>
            </div>
          </div>
          <div class="profile-actions">
            <button class="primary-btn" @click="handleConfirmClick">确定</button>
          </div>
        </div>
      </transition>
    </div>


  </div>
</template>

<script>
import SideBar from '@/components/SideBar/index.vue'; 
export default {
  data() {
    return {
      selectedIndex: -1, // 当前选中卡片索引，-1 表示未选中
      hoveredIndex: -1, // 当前鼠标悬停的卡片索引，-1 表示未悬停
      isFeedbackModalVisible: false,
      items: [
        { id: 2, image: require("../interview_ing/assets/img/quiet_Scene2.gif"), name: 'Kyle' },
        { id: 3, image: require("../interview_ing/assets/img/quiet_Scene1.gif"), name: 'Cathy' },
      ],
      profileInfo: {
        name: 'Cathy',
        intros: [
          '身份：治愈系面试「养成系NPC」',
          '主动技「温柔引导波」：看你紧张会触发语音彩蛋:"宝!深呼吸~这局咱们主打真实",卡壳时自动递「思路提示包」(举个栗子or换角度唠唠?)',
          '被动「潜力雷达」：从你的故事里挖闪光点,面试后给「成长 Buff 指南」:"你沟通力拉满!但行业认知可以戳这几个资源补~"',
          '●适配玩家：需要「情绪兜底」的新手/社恐!比如—————',
          '√ 第一次面试怕尴尬想找搭子',
          '√ 面软技能岗(市场/运营)想松弛输出',
          '√ 主打一个:"我要边面边攒自信!"',
        ]
      }
    };
  },
  components: {
    SideBar
  },
  computed: {
    headerJustify() {
    return this.currentProfileInfo.name === 'Cathy' ? 'flex-start' : 'flex-end';
  },
    currentProfileInfo() {
      if (this.selectedIndex === -1) {
        return this.profileInfo;
      }
      
      const selectedItem = this.items[this.selectedIndex];
      if (selectedItem.name === 'Kyle') {
        return {
          name: 'Kyle',
          intros: [
            '💬身份: 理性系面试「副本考官」',
            '战斗风格:',
            '技能「逻辑穿刺」：不管你说多花哨的经历,直接锁定「经历真实性+岗位适配漏洞」,一个追问让你暴露真实水平(别怕,是帮你补破绽!)',
            '被动「数据之眼」：把大厂面评标准(谷歌OKR/宝洁八大问)当技能包,用理性框架拆解你的回答,输出「职业战斗力分析报告」',
            '💡适配玩家：想被「硬核打磨」的卷王!比如—————',
            '✔️技术岗想秀实力但怕漏细节',
            '✔️面管培生岗想练逻辑推导',
            '✔️直接开卷:"来!让我看看自己几斤几两"',
          ]
        };
      } else if (selectedItem.name === 'Cathy') {
        return {
          name: 'Cathy',
          intros: [
            '💬身份：治愈系面试「养成系NPC」',
            '主动技「温柔引导波」：看你紧张会触发语音彩蛋:"宝!深呼吸~这局咱们主打真实",卡壳时自动递「思路提示包」(举个栗子or换角度唠唠?)',
            '被动「潜力雷达」：从你的故事里挖闪光点,面试后给「成长 Buff 指南」:"你沟通力拉满!但行业认知可以戳这几个资源补~"',
            '💡适配玩家：需要「情绪兜底」的新手/社恐!比如—————',
            '✔️第一次面试怕尴尬想找搭子',
            '✔️面软技能岗(市场/运营)想松弛输出',
            '✔️主打一个:"我要边面边攒自信!"',
          ]
        };
      }
      
      return this.profileInfo;
    }
  },
  mounted() {
    this.observeFeedbackModal();
  },
  methods: {
    observeFeedbackModal() {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const feedbackModal = document.querySelector('.feedback-modal');
            this.isFeedbackModalVisible = !!feedbackModal;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
    // 处理卡片点击事件
    handleCardClick(index) {
      // 点击切换选中状态，若已选中同一张则可做取消逻辑（根据需求调整）
      this.selectedIndex = this.selectedIndex === index ? -1 : index; 
    },
    // 处理鼠标进入事件
    handleMouseEnter(index) {
      // 鼠标滑过时显示勾选状态
      this.hoveredIndex = index;
    },
    // 处理鼠标离开事件
    handleMouseLeave() {
      // 鼠标离开时清除勾选状态
      this.hoveredIndex = -1;
    },
    confirmSelection() {
      if (this.selectedIndex === -1) {
        return null; 
      }
      const selectedInterviewer = this.items[this.selectedIndex];
      console.log('选择的面试官:', selectedInterviewer);
      return selectedInterviewer.id;
    },
    handleConfirmClick() {
      const selectedId = this.confirmSelection();
      if (selectedId === null) {
        this.$message({
          message: '请先选择一位面试官',
          type: 'warning',
          duration: 2000
        });
        return;
      }
      if (selectedId === 3) {
        this.$router.push({ path: '/store/interview_pre', query: { selectedId: selectedId } });
      } else {
        this.$message({
          message: '数字人正在开发中~',
          type: 'warning',
          duration: 2000
        });
      }
    },

  }
};
</script>

<style scoped lang="css" src="./assets/index.response.css" />

<style scoped>
/* 基础容器 - 使用视口单位确保比例一致 */
.page { 
  position: relative; 
  width: 100vw; 
  height: 100vh; 
  padding: 2vh 2vw 4vh; 
  box-sizing: border-box;
  overflow: hidden;
}

.login-btn { 
  position: absolute; 
  top: 2vh; 
  right: 2vw; 
  z-index: 10;
}

.title-row { 
  width: 100%; 
  display: flex; 
  justify-content: center; 
  margin-top: 4vh; 
}

.page-title { 
  font-size: 32px; 
  font-weight: 700; 
  background: linear-gradient(90deg,#4e9afc,#a97df5); 
  background-clip: text; 
  -webkit-background-clip: text; 
  color: transparent; 
}

/* 主舞台区域 - 使用视口单位保持比例 */
.stage { 
  position: relative; 
  width: 100%; 
  height: 70vh; 
  display: flex; 
  justify-content: center; 
  align-items: flex-end; 
  margin-top: 4vh; 
  padding: 0 2vw; 
  box-sizing: border-box; 
}

.characters { 
  position: relative; 
  width: 100%; 
  height: 100%; 
  max-width: 90vw;
}

.characters.with-panel { 
  transition: all .35s ease; 
}

/* 角色卡片 - 使用视口单位保持比例 */
.character { 
  position: absolute; 
  bottom: 0; 
  cursor: pointer; 
  transition: transform .45s ease, filter .35s ease, opacity .35s ease, left .45s ease, right .45s ease; 
}

.character.pos-left { 
  left: 15%; 
  transform-origin: left bottom; 
}

.character.pos-right { 
  right: 15%; 
  transform-origin: right bottom; 
}

/* 当有面板显示时，角色移动到更靠边的位置 */
.characters.with-panel .character.pos-left { 
  left: 5%; 
}

.characters.with-panel .character.pos-right { 
  right: 5%; 
}

.character.is-dimmed { 
  filter: grayscale(40%) brightness(0.85); 
}

.character.is-selected { 
  transform: scale(1.25); 
  z-index: 2; 
}

/* 角色图片 - 使用视口单位保持比例 */
.character-image { 
  width: clamp(250px, 22vw, 480px); 
  height: clamp(500px, 44vw, 960px); 
  background-size: contain; 
  background-position: center bottom; 
  background-repeat: no-repeat; 
}

.select-dot { 
  width: clamp(12px, 1.2vw, 20px); 
  height: clamp(12px, 1.2vw, 20px); 
  border-radius: 50%; 
  border: 2px solid #8fb7ff; 
  margin: clamp(8px, 1.5vw, 20px) auto 0; 
  visibility: hidden; 
  opacity: 0; 
  transform: translateY(6px); 
  transition: opacity .25s ease, transform .25s ease, visibility .25s ease; 
}

.character:hover .select-dot { 
  visibility: visible; 
  opacity: 1; 
  transform: translateY(0); 
}

.character.is-selected .select-dot { 
  display: none; 
}

.select-dot.checked { 
  background: #8fb7ff; 
  box-shadow: 0 0 0 3px rgba(143,183,255,.25); 
}

/* 资料面板容器 - 使用视口单位保持比例 */
.profile-container { 
  position: absolute; 
  left: 50%; 
  top: 2vh; 
  transform: translateX(-50%); 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  gap: clamp(12px, 1.5vw, 20px); 
  margin-bottom: 8vh; 
}

/* 资料面板 - 使用视口单位保持比例 */
.profile-panel { 
  width: clamp(400px, 45vw, 750px); 
  max-height: 60vh; 
  overflow-y: auto; 
  background: rgba(255,255,255,.2); 
  backdrop-filter: blur(10px); 
  border-radius: clamp(8px, 1.2vw, 16px); 
  padding: clamp(16px, 2.5vw, 32px) clamp(20px, 3vw, 36px); 
  box-shadow: 0 10px 30px rgba(0,0,0,.06); 
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* 隐藏Webkit浏览器的滚动条 */
.profile-panel::-webkit-scrollbar {
  display: none;
}

.profile-header { 
  display: flex; 
  margin-bottom: clamp(8px, 1.2vw, 16px); 
}

.profile-name { 
  font-size: clamp(0.96rem, 1.76vw, 1.6rem); 
  font-weight: 700; 
  color: #6a87ff; 
}

.profile-body { 
  color: #4b4b4b; 
  line-height: 1.9; 
  font-size: clamp(0.56rem, 0.88vw, 0.88rem); 
}

.profile-list { 
  padding-left: clamp(12px, 1.8vw, 24px); 
  font-size: 18px; 
}

.profile-list li { 
  margin-bottom: clamp(4px, 0.8vw, 12px); 
}

.profile-list li.section-title { 
  font-weight: 600; 
  color: #6a87ff; 
  margin-top: clamp(12px, 1.6vw, 20px); 
  margin-bottom: clamp(4px, 0.8vw, 12px); 
}

.profile-list li.check-item { 
  color: #4b4b4b; 
  padding-left: clamp(4px, 0.8vw, 12px); 
}

.profile-actions { 
  display: flex; 
  justify-content: center; 
}

.primary-btn { 
  height: clamp(36px, 4.4vh, 48px); 
  padding: 0 clamp(24px, 4vw, 48px); 
  border: 0; 
  border-radius: clamp(18px, 2.2vh, 24px); 
  background: linear-gradient(90deg,#6aa5ff,#a884ff); 
  color: #fff; 
  cursor: pointer; 
  font-size: clamp(0.64rem, 1.04vw, 1.04rem); 
  font-weight: 600; 
  box-shadow: 0 4px 12px rgba(106,165,255,0.3); 
  transition: all 0.3s ease; 
}

.primary-btn:hover { 
  transform: translateY(-2px); 
  box-shadow: 0 6px 16px rgba(106,165,255,0.4); 
}

.back-btn { 
  background: linear-gradient(90deg,#7b8ab5,#9ba3b8); 
  box-shadow: 0 4px 12px rgba(123,138,181,0.3); 
}

.back-btn:hover { 
  box-shadow: 0 6px 16px rgba(123,138,181,0.4); 
}

/* 面板过渡动画 */
.panel-enter-active, .panel-leave-active { 
  transition: opacity .35s ease, transform .35s ease; 
}

.panel-enter-from, .panel-leave-to { 
  opacity: 0; 
  transform: translateY(16px) scale(.98); 
}

/* 响应式断点优化 */
@media (max-width: 1200px) {
  .character.pos-left { left: 12%; }
  .character.pos-right { right: 12%; }
  
  .characters.with-panel .character.pos-left { left: 3%; }
  .characters.with-panel .character.pos-right { right: 3%; }
}

@media (max-width: 768px) {
  .stage { 
    height: 65vh; 
    margin-top: 3vh; 
  }
  
  .character.pos-left { left: 8%; }
  .character.pos-right { right: 8%; }
  
  .characters.with-panel .character.pos-left { left: 2%; }
  .characters.with-panel .character.pos-right { right: 2%; }
  
  .profile-container { 
    gap: clamp(8px, 1vw, 12px); 
    margin-bottom: 6vh; 
  }
  
  .title-row { 
    margin-top: 3vh; 
  }
}

@media (max-width: 480px) {
  .stage { 
    height: 60vh; 
  }
  
  .character.pos-left { left: 5%; }
  .character.pos-right { right: 5%; }
  
  .characters.with-panel .character.pos-left { left: 1%; }
  .characters.with-panel .character.pos-right { right: 1%; }
  
  .profile-panel { 
    width: 90vw; 
    max-width: 90vw; 
  }
}
</style>